import { html } from 'lit';

export default html`
  <div class="text-white text-xs mb-12 mx-4 leading-normal">
    <ul>
      <li class="inline px-2 border-r border-white">
        CUSTOMER SERVICE: Australia:<a href="tel:+61 38311501" class="underline"
          >+61 38311501</a
        >
      </li>
      <li class="inline px-2 border-r border-white">
        Europe:
        <a href="tel:+8000 183 909" class="underline">+8000 183 909</a>,<a
          href="tel:+44 (0) 20 3750 6073"
          >+44 (0) 20 3750 6073</a
        >
      </li>
      <li class="inline px-2 border-r border-white">
        Hong Kong:
        <a href="tel:+852 22817502" class="underline">+852 22817502</a>
      </li>
      <li class="inline px-2 border-r border-white">
        Japan:
        <a href="tel:+81-726299066" class="underline">+81-726299066</a
        >(English),
        <a href="tel:+81-727368473" class="underline">+81-727368473</a
        >(Japanese)
      </li>
      <li class="inline px-2 border-r border-white">
        Singapore:
        <a href="tel:+65 65053912" class="underline">+65 65053912</a>
      </li>
      <li class="inline px-2">
        North America:<a href="tel:+1.877.357.7782" class="underline"
          >+1.877.357.7782</a
        >
      </li>
    </ul>
    <ul>
      <li class="inline px-2">
        <a href="mailto:customersuccessteam@digitalrealty.com" class="underline"
          >customersuccessteam@digitalrealty.com</a
        >
      </li>
    </ul>
    <ul>
      <li class="inline px-2 border-r border-white">
        <a
          href="https://www.digitalrealty.com/acceptable-use-policy/"
          class="underline"
          rel="noopener noreferrer"
          target="_blank"
          >Acceptable Use Policy</a
        >
      </li>
      <li class="inline px-2">
        <a
          href="https://www.digitalrealty.com/privacy"
          class="underline"
          rel="noopener noreferrer"
          target="_blank"
          >Privacy</a
        >
      </li>
    </ul>
  </div>
`;
